module.exports = __webpack_public_path__ + "static/img/avatar_2.2c4c39c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/images/avatar_2.png
// module id = W3T8
// module chunks = 28